"use client";
import React from 'react';
import { Check } from "lucide-react";

const WhyUs = ({ data }) => {
  // Safety check to prevent crashes if data is incomplete
  if (!data?.Cards || data.Cards.length < 3) return null;

  return (
    <section 
      className="py-5 md:py-5 bg-white" 
      aria-labelledby="why-us-title"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          
          {/* Left Side: Content */}
          <header className="lg:w-5/12 text-center lg:text-left">
            <span className="inline-block text-[#4F7AC2] bg-[#4F7AC2]/10 px-4 py-1 rounded-md text-sm font-bold border border-[#4F7AC2]/20 mb-6 tracking-wide uppercase">
              {data.subTitle}
            </span>
            <h2 
              id="why-us-title"
              className="text-4xl md:text-5xl font-extrabold text-[#001c3d] mb-8 leading-[1.1] tracking-tight"
            >
              {data.title}
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0">
             {data.description}
            </p>
          </header>

          {/* Right Side: Staggered Cards */}
          <div className="lg:w-7/12 flex flex-col md:flex-row gap-6 items-center">
            
            {/* Column 1 (Taller) */}
            <ul className="flex flex-col gap-6 w-full md:w-1/2 list-none p-0 m-0">
              {[data.Cards[0], data.Cards[2]].map((card, idx) => (
                <li 
                  key={idx}
                  className="bg-white p-8 rounded-2xl border border-gray-100 shadow-[0_10px_40px_rgba(0,0,0,0.03)] hover:shadow-xl hover:border-blue-50 transition-all duration-300 group"
                >
                  <div 
                    className="w-14 h-14 bg-blue-50/50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors"
                    aria-hidden="true"
                  >
                     <Check className="w-8 h-8 text-[#4F7AC2] stroke-[3px]" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#001c3d] mb-4">
                    {card.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {card.description}
                  </p>
                </li>
              ))}
            </ul>

            {/* Column 2 (Offset) */}
            <div className="w-full md:w-1/2">
              <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-[0_10px_40px_rgba(0,0,0,0.03)] hover:shadow-xl hover:border-blue-50 transition-all duration-300 group">
                <div 
                  className="w-14 h-14 bg-blue-50/50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors"
                  aria-hidden="true"
                >
                   <Check className="w-8 h-8 text-[#4F7AC2] stroke-[3px]" />
                </div>
                <h3 className="text-2xl font-bold text-[#001c3d] mb-4">
                  {data.Cards[1].title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {data.Cards[1].description}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
